module.exports = __webpack_public_path__ + "static/img/fate.6f90135.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fate.jpg
// module id = pTAb
// module chunks = 0